import { createGlobalStyle } from "styled-components";

// global style for the tooltip since it;s rendered as a portal
const TooltipStyles = createGlobalStyle`
  .styled-tooltip .ant-tooltip-inner {
    font-size: 12px;
    font-weight: 500;
    min-height: auto;
    padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
    border-radius: ${({ theme }) => theme.borderRadiusContainers};
    white-space: nowrap;
    box-shadow: 0 4px 12px ${({ theme }) => theme.blackTransparent};
    bottom: 0;
    position: static;
  }

  .styled-tooltip.ant-tooltip-placement-top .ant-tooltip-arrow,
  .styled-tooltip.ant-tooltip-placement-topLeft .ant-tooltip-arrow,
  .styled-tooltip.ant-tooltip-placement-topRight .ant-tooltip-arrow {
    border-top-color: ${({ theme }) => theme.backgroundDark};
  }
`;

export default TooltipStyles;
